$('#hamburger').click(
   function(){ $(".menu, .close, .main-nav, .site-header").toggleClass('open') }
);

$('.has_subnav').click(
   function(){ $(this).toggleClass('open') }
);



//COLOR SKIN CODE
$(document).ready(function(){
  if ($("#color-theme").hasClass("brown")){
    $("body").addClass("brown-theme");
  };
  if ($("#color-theme").hasClass("navy")){
    $("body").addClass("navy-theme");
  };
});


//HOME PAGE PARALLAX EFFECT
if ($('.ddl-hero').length > 0) {
  var scene = document.getElementById('scene');
  var parallaxInstance = new Parallax(scene,{
    limitX: 0
  });
}

if ($('.collection-header').length > 0) {
  var scene = document.getElementById('scene');
  var parallaxInstance = new Parallax(scene,{
    limitX: 0
  });
}

//DDL CUSTOM HOME PAGE SLIDERS
$('.ddl-slideshow').slick({
  dots: true,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 5000
});



//CUSTOM COLLECTION SLIDERS
$(".collection-slider").slick({
  slidesToShow: 4,
  centerMode: false,
  autoplay: true,
  autoplaySpedd: 9000,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        centerMode: true
      }
    },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 2
    }
  },
  {
    breakpoint: 400,
    settings: {
      slidesToShow: 1
    }
  }
]
});

//PRODUCT PAGE GALLERY
function myFunction(imgs) {
  // Get the expanded image
  var expandImg = document.getElementById("expandedImg");
  // Use the same src in the expanded image as the image being clicked on from the grid
  expandImg.src = imgs.src;
  // Show the container element (hidden with CSS)
  expandImg.parentElement.style.display = "block";
}
$(".gallery-thumbs .thumb:first-child").click();


//PRODUCT PAGE TABS
function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}
document.getElementById("defaultOpen").click();


jQuery(document).ready(function(){
    // This button will increment the value
    $('[data-quantity="plus"]').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $('[data-quantity="minus"]').click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
});






jQuery(document).ready(function(){
  var cartbutton = $('.product-controls').offset();
  var $window = $(window);

  $window.scroll(function(){
    if ( $window.scrollTop() >= cartbutton.top) {
      $('.product-controls').addClass("fixed");
    }
    if ( $window.scrollTop() <= cartbutton.top) {
      $('.product-controls').removeClass("fixed");
    }
  });
});
